"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAccessibleColor = void 0;
var _getContrastRatio = require("./getContrastRatio");
const contrastRatioMap = {
  minimum: {
    normalText: 4.5,
    largeText: 3,
    graphic: 3
  },
  enhanced: {
    normalText: 7,
    largeText: 4.5,
    graphic: 3
  }
};
/**
 * isAccessibleColor will default to using "minimum" contrast ratios
 * If you prefer to use "enhanced" ratios you can pass a fourth argument of `true`
 * Contrast ratios can range from 1 to 21 (commonly written 1:1 to 21:1).
 * 7 - "enhanced" contrast for regular sized text under WCAG 2.0 1.4.6 (Level AAA)
 * 4.5 - minimum contrast for regular sized text under WCAG 2.0 1.4.3 (Level AA)
 * 3 - minimum contrast for "large scale" text (18 pt or 14 pt bold, or larger) under WCAG 2.0 1.4.3 (Level AA)
 * https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html
 */
const isAccessibleColor = ({
  background,
  foreground,
  usage,
  enhanced
}) => {
  const ratio = (0, _getContrastRatio.getContrastRatio)(background, foreground);
  return ratio >= contrastRatioMap[enhanced ? 'enhanced' : 'minimum'][usage];
};
exports.isAccessibleColor = isAccessibleColor;